export enum ProvidersColor {
    bookboon = '#F59833',
    udemy = '#EA5252',
    openclassroom =  '#7550EB',
    edflex =  '#216AB2',
    cefora = '#251B5A'
}
